import { Link } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { FormControl, TextField } from "@mui/material";
import TalentsApiService from "../../TalentsApiService";
import * as Constants from "./../../constants";
import EmailIcon from "@mui/icons-material/Email";
import { toast, ToastContainer } from "react-toastify";
import Button from "../../components/reusableElementsComponents/Button";
import { InputAdornment } from "@mui/material";
import { t } from "../../content";
import { useLocale } from "../../locale";
import AuthPageChrome from "../../components/layoutComponents/authComponents/AuthPageChrome";

function RecoverPassword() {
  const { withLocale, locale } = useLocale();
  const apiObject = useMemo(() => {
    return new TalentsApiService();
  }, []);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [disable, setDisable] = useState(true);

  useEffect(() => {
    if (email.length > 0) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [email]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!Constants.VALID_EMAIL.test(email)) {
      setEmailError(true);
      return;
    } else {
      setEmailError(false);
    }
    const passwordResetEmailSent = toast.loading(t("auth.toasts.sendingEmail"), {
      containerId: "forgot-password-email",
    });
    if (email) {
      try {
        const response = await apiObject.ForgotPasswordEmail({ email, locale });
        if (response.httpStatus === 200 && response.json.status === true) {
          toast.update(passwordResetEmailSent, {
            render: t("auth.toasts.resetLinkSent"),
            type: "success",
            isLoading: false,
            autoClose: 2000,
            closeButton: true,
            hideProgressBar: true,
          });
        } else if (response.httpStatus === 404) {
          toast.update(passwordResetEmailSent, {
            render: t("auth.toasts.emailNotFound"),
            type: "error",
            isLoading: false,
            autoClose: 2000,
            closeButton: true,
            hideProgressBar: true,
          });
        } else {
          toast.update(passwordResetEmailSent, {
            render: t("auth.toasts.genericError"),
            type: "error",
            isLoading: false,
            autoClose: 2000,
            closeButton: true,
            hideProgressBar: true,
          });
        }
      } catch (error) {
        toast.update(passwordResetEmailSent, {
          render: t("auth.toasts.genericError"),
          type: "error",
          isLoading: false,
          autoClose: 2000,
          closeButton: true,
          hideProgressBar: true,
        });
      }
    }
  };

  return (
    <div className="auth-page-wrapper">
      <AuthPageChrome />
      <div className="form-wrapper">
        <Link
          className="back-to-login-link bold reg-as-talent regular"
          to={withLocale("/login")}
        >
          <p className="m-0 light">
            {"<< "}
            {t("auth.recover.backToLogin")}
          </p>
        </Link>
        <br />
        <ToastContainer containerId="forgot-password-email" />

        <h3 className="title semi-bold">{t("auth.recover.titleDesktop")}</h3>
        <p className="grey s">{t("auth.recover.subtitleDesktop")}</p>
        <form className="form" onSubmit={handleSubmit}>
          <FormControl fullWidth>
            <TextField
              placeholder={t("auth.recover.emailPlaceholder")}
              id="email"
              name="email"
              type="text"
              autoComplete="on"
              value={email}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <EmailIcon />
                  </InputAdornment>
                ),
              }}
              variant="standard"
              onChange={(e) => setEmail(e.target.value)}
            />
          </FormControl>
          {emailError && (
            <div>
              <p style={{ color: "red" }}>{t("validation.validEmail")}</p>
            </div>
          )}
          <div className="authButtons">
            <Button
              btnstyle={
                disable
                  ? "mazhrBtn light-grey white"
                  : "mazhrBtn default-green white"
              }
              type="submit"
              disabled={disable}
            >
              <p className="m-0 light">{t("auth.recover.sendLink")}</p>
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default RecoverPassword;
